import axios from 'axios'
// import store from "../store";
import { serialize } from '@/utils/util'
import { Toast } from 'vant'
let chaoyangUrl = ['/home/index', '/home/lists', '/home/info'];
// let jiaqiUrl = ['/exueyun-boss-consumer/webUser/validUserAccountForAppDownload'];
let juchenUrl = ['/exueyun-client-consumer/clientSlideShow/addReading']
const qs = require('qs')
// 创建axios实例
const service = axios.create({
  // baseURL: 'http://192.168.1.108:8086', // api 的 base_url
  // baseURL: 'https://dev-boss.zqycloud.com/api/', // 测试api 的 base_url
  // baseURL: 'http://101.34.92.142:20000/gateway', // 测试api 的 base_url
  baseURL: 'https://boss.zqycloud.com/gateway', // 正式api 的 base_url
  timeout: 5000, // 请求超时时间
})
// request拦截器
service.interceptors.request.use(
  (config) => {
    // console.log(config)
    // 原token
    // if (store.getters.access_token) {
    //   config.headers["Authorization"] = "Bearer " + store.getters.access_token;
    // }
    if (config.method === 'get' || config.method === 'delete') {
      config.paramsSerializer = function (params) {
        return qs.stringify(params, { arrayFormat: 'repeat' })
      }
    }
    // headers中配置serialize为true开启序列化
    if (config.method === 'post' && config.headers.serialize) {
      config.data = serialize(config.data)
      delete config.data.serialize
    }

    if(config.method === 'post'){
      // if()
      // console.log("config.data = " + JSON.stringify(config.data))
      if(config.data.hasOwnProperty('Authorization')){
        config.headers["Authorization"] = config.data.Authorization
      }
    }
    if(config.method === 'get'){
      // if()
      if(config.params.hasOwnProperty('Authorization')){
        config.headers["Authorization"] = config.params.Authorization
      }
    }

    

    config.headers["Version"] = 'v1';
    config.headers["Source"] = 'H5';
    // config.headers["Access-Token"] = '7a6d0210dca062305c3ae6a230693697,19688f9d-a26b-460d-b036-db8732d6ed35';
    // config.headers["Authorization"] = 'd2d8cf1d13681a7ac0eeb9877af96f7a,5b653e60-914a-11eb-a788-0242ac160002';
    let timeup = (Date.parse(new Date()) / 1000).toString();
    let uniqueKey = Math.floor(Math.random() * 90 + 10) + timeup.substring(5, 10) + timeup.substring(0, 5) + Math.floor(Math.random() * 90 + 10);
    config.headers['unique-key'] = uniqueKey;
    config.url = config.url.replace('/api', '')
    // if(chaoyangUrl.includes(config.url)) {
    //   config.baseURL = 'https://dev-e-school.qxueyun.com' //test
    //   // config.baseURL = 'https://eschool.qxueyun.com' //prod
    // }
    if (juchenUrl.includes(config.url)) {
      config.baseURL = 'https://boss.zqycloud.com/gateway' //test
      //prod
    }
    // if(jiaqiUrl.includes(config.url)) {
    //   // config.baseURL = 'https://boss.qxueyun.com/gateway'
    //   config.baseURL = 'https://dev-boss.zqycloud.com/api/'
    // }
    return config
  },
  (error) => {
    // Do something with request error
    Promise.reject(error)
  }
)
// response 拦截器
service.interceptors.response.use(
  (response) => {
    if (response.status !== 200) {
      return Promise.resolve(false)
    } else {
      // let code = response.data.code === undefined ? 0 : response.data.code;
      // if (response.data.code != 200) {
      //   Toast(response.data.errorMsg)
      // }
      return response.data
    }
  },
  (error) => {
    // let res = error.response;
    // if (res.status == 401) {
    //   top.postMessage("401", "*");
    // }
    return Promise.reject(error)
  }
)
// 超时重新请求
service.interceptors.response.use(undefined, function axiosRetryInterceptor(err) {
  var config = err.config
  config['retry'] = 4
  config['retryDelay'] = 1000
  if (!config || !config.retry) return Promise.reject(err)
  config.__retryCount = config.__retryCount || 0
  if (config.__retryCount >= config.retry) {
    return Promise.reject(err)
  }
  config.__retryCount += 1
  var backoff = new Promise(function (resolve) {
    setTimeout(function () {
      resolve()
    }, config.retryDelay || 1)
  })
  return backoff.then(function () {
    return service(config)
  })
})
export default service